import { forwardRef } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MdDateRange } from 'react-icons/md';
import { useState } from 'react';
import { getCurrentI18nLanguage } from '../../i18n';
import 'dayjs/locale/nb';

export const DatepickerV2 = forwardRef(
  (
    { locale = 'nb', iconSize = 16, ...props }: DatePickerProps & { locale?: string; iconSize?: number },
    _ref,
  ) => {
    const [open, setOpen] = useState(false);
    const { datepickerLocale } = getCurrentI18nLanguage();
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale || datepickerLocale.code}>
        <DatePicker
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slotProps={{
            field: {
              readOnly: true,
            },
            textField: {
              InputProps: {
                startAdornment: <MdDateRange size={iconSize} className="text-brand-primary hover:cursor-pointer" />,
                endAdornment: <></>,
                onClick: () => {
                  setOpen(true);
                },
                className: 'gap-2 !text-sm',
              },
            },
          }}
          {...props}
        />
      </LocalizationProvider>
    );
  },
);

DatepickerV2.displayName = 'DatepickerV2';

export default DatepickerV2;
